import React from 'react';
import {observer} from 'mobx-react';
import ReactSelect from 'shared/components/ReactSelect';
import { observable, makeObservable } from 'mobx';
import DropdownFilterState from 'main/components/tables/interactive/components/dropdown_filter/DropdownFilterState';

class DropdownFilter extends React.Component {
  uiState;

  constructor(props) {
    super(props);

    makeObservable(this, {
      uiState: observable
    });
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    this.uiState = new DropdownFilterState(this.props);
  }

  render() {
    const {uiState} = this;

    return (
      <div className='DropdownFilter nowrap'>
        <ReactSelect selected={uiState.selected.display}>
          {uiState.options.map(option =>
            <ReactSelect.Option active={uiState.selected.id === option.id}
                                key={option.id} text={option.display}
                                onClick={() => uiState.changeOption(option)}/>)}
        </ReactSelect>
      </div>
    );
  }
}

export default observer(DropdownFilter);
